import React from 'react';
import CategoryButton from '../../../components/common/CategoryButton';

const StatsCategorySelector = ({ categories, selectedCategory, onSelect, language }) => {
    return (
        <div className="-mx-6 md:mx-0">
            <div className="flex md:grid md:grid-cols-5 gap-3 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none no-scrollbar px-6 md:px-0 pb-2 md:pb-0">
                {categories.map((cat) => (
                    <div key={cat.id} className="flex-shrink-0 md:flex-shrink snap-center w-[140px] md:w-auto">
                        <CategoryButton
                            category={cat}
                            isSelected={selectedCategory === cat.id}
                            onClick={onSelect}
                            language={language}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StatsCategorySelector;
